export default "__VITE_ASSET__cde9fe03__"